import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import { UploadOutlined } from "@ant-design/icons";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { Row, Col, Button, Form, Input, message, Spin, Upload } from "antd";

const AddNewFuelProvider = () => {
  const [loading, setLoading] = useState(false);
  const UserID = localStorage.getItem("AdminID");
  const AccessKey = localStorage.getItem("AdminAccessKey");
  const [messageApi, contextHolder] = message.useMessage();
  const [logoLoginFile, setLogoLoginFile] = useState(null);
  const [logoReportsFile, setLogoReportsFile] = useState(null);
  const [logoTitleFile, setLogoTitleFile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Add New Fuel Provider";
  }, []);

  const handleLogoLoginChange = (info) => {
    setLogoLoginFile(info.fileList[0]?.originFileObj || null);
  };

  const handleLogoReportsChange = (info) => {
    setLogoReportsFile(info.fileList[0]?.originFileObj || null);
  };

  const handleLogoTitleChange = (info) => {
    setLogoTitleFile(info.fileList[0]?.originFileObj || null);
  };

  const handleSubmit = (formData) => {



    setLoading(true);

    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ...formData,
    };


    const api_config = {
      method: "post",
      url: `${config.base_url}/your-endpoint`, 
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data,
    };

    axios(api_config)
      .then((response) => {
        if (response.data.status_code === 1) {
          message.success(response.data.status_message);
        } else {
          message.error(response.data.status_message || "Something went wrong");
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("An error occurred while adding the fuel provider.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {contextHolder}
      <div className="right-side-contents">
        <div className="page-content">
          <Row>
            <Col span={12}>
              <div className="page-header">
                <h6 className="page-title">
                  <NavLink to="/controlbase/fuelprovider">
                    <ChevronLeftIcon />
                  </NavLink>
                  Add New Fuel Provider
                </h6>
              </div>
            </Col>
          </Row>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Form
                name="basic"
                layout="horizontal"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                initialValues={{ remember: true }}
                onFinish={handleSubmit}
                autoComplete="off"
                size="large"
              >
                <Form.Item
                  label="Fuel Provider Name"
                  name="ProviderName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Fuel Provider Name",
                    },
                  ]}
                >
                  <Input placeholder="Enter Fuel Provider Name" />
                </Form.Item>

                <Form.Item
                  label="Logo_Login"
                  name="Logo_Login"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Fuel Provider Logo",
                    },
                  ]}
                >
                  <Upload
                    name="logo"
                    accept="image/*"
                    fileList={logoLoginFile ? [logoLoginFile] : []}
                    onChange={handleLogoLoginChange}
                    beforeUpload={() => false}
                  >
                    <Button icon={<UploadOutlined />}>Select File</Button>
                  </Upload>
                </Form.Item>

                <Form.Item
                  label="Logo_Reports"
                  name="Logo_Reports"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Fuel Provider Logo",
                    },
                  ]}
                >
                  <Upload
                    name="logo"
                    accept="image/*"
                    fileList={logoReportsFile ? [logoReportsFile] : []}
                    onChange={handleLogoReportsChange}
                    beforeUpload={() => false}
                  >
                    <Button icon={<UploadOutlined />}>Select File</Button>
                  </Upload>
                </Form.Item>

                <Form.Item
                  label="Logo_Title"
                  name="Logo_Title"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Fuel Provider Logo",
                    },
                  ]}
                >
                  <Upload
                    name="logo"
                    accept="image/*"
                    fileList={logoTitleFile ? [logoTitleFile] : []}
                    onChange={handleLogoTitleChange}
                    beforeUpload={() => false}
                  >
                    <Button icon={<UploadOutlined />}>Select File</Button>
                  </Upload>
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                  <Button
                    type="primary"
                    size="large"
                    shape="round"
                    htmlType="submit"
                    loading={loading}
                  >
                    {loading ? <Spin /> : "Add Petrol Pump"}
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default AddNewFuelProvider;